<header class="header d-flex justify-content-between">
  <plys-shop-logo></plys-shop-logo>
  @if (themeSet) {
    <plys-timer [time]="time$ | async" [expired]="expiredError$ | async"></plys-timer>
  }
</header>

<!-- `seatSelectionType$` stays first: its subscription is what keeps the step flow in sync, and a
later condition short-circuiting it would silence that. -->
@if ((seatSelectionType$ | async) !== null && checkoutReady && (stateService.reinitializing$ | async) === false) {
  <main class="main">
    <router-outlet></router-outlet>
  </main>
} @else {
  <main class="main flex-column flex-md-row">
    <div class="order-1 col-12 offset-md-1 col-md-7">
      <div class="card ghost-element" style="height: 400px"></div>
    </div>
    <div class="d-none d-md-block order-0 col-12 order-md-1 col-md-3">
      <div class="ghost-element"></div>
    </div>
  </main>
}

<!-- Empty until the staging-only debugger chunk lands; `ngComponentOutlet` renders nothing for null. -->
<ng-container *ngComponentOutlet="stateDebugger"></ng-container>
